import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { SubmitBotFormPage } from 'features/botd'

import { canViewAnalyticsPermission } from '../../../../../hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/submit-bot')({
  component: SubmitBotFormPage,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Submit bot'),
      },
    ],
  }),
  beforeLoad: async (ctx) => {
    await protectWithWorkspacePermissions(canViewAnalyticsPermission)(ctx)
  },
})
